import React, { forwardRef } from 'react';

const Input = forwardRef((props, ref) => {

  const handleChange = (event) => {
    const newValue = event.target.value.replace(/^\s+/, '');
    event.target.value = newValue;
    if (newValue.trim() === '') {
      event.target.value = '';
      props.onChange(event);
    } else {
      props.onChange(event);
    }
  };

  return (
    <input
        id = {props.id}
        tabIndex = {props.tabIndex}
        className = {props.className}
        name = {props.name}
        data-id = {props.dataId}
        data-type = {props.dataType}
        onFocus = {props.onFocus}
        maxLength = {props.maxLength}
        autoFocus = {props.autoFocus}
        value = {props.value}
        onChange = {handleChange}
        onKeyDown = {props.onKeyDown}
        onClick = {props.onClick}
        onBlur = {props.onBlur}
        disabled = {props.disabled}
        placeholder = {props.placeholder}
        readOnly = {props.readOnly}
        ref={ref}  // Attach the ref here
        style={props.style}
        type={props.type}
        min={props.min}
        step={props.step}
        key={props.key}
        defaultValue={props.defaultValue}
        pattern={props.pattern}
        onPaste={props.onPaste}
    />
  );
});

export default Input;



// WEBPACK FOOTER //
// ./src/components/Input/index.js